import { useState } from 'react';
import { HiMail, HiLocationMarker } from 'react-icons/hi';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const Contact = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    
    const formData = new FormData(form);
    
    fetch(form.action, {
      method: 'POST',
      body: formData
    })
    .then(() => {
      setShowSuccess(true);
      form.reset();
      setTimeout(() => setShowSuccess(false), 5000);
    })
    .catch(() => {
      alert('There was an error sending your message. Please try again.');
    });
  };

  return (
    <section id="contact" className="min-h-[100svh] sm:min-h-0 py-10 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white dark:bg-black flex items-center transition-colors duration-300">
      <div className="max-w-6xl mx-auto w-full">
        {/* Section Title */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-bold text-black dark:text-white mb-4 transition-colors duration-300">
            Get In Touch
          </h2>
          <div className="w-16 h-1 bg-black dark:bg-white mx-auto transition-colors duration-300"></div>
          <p className="mt-4 sm:mt-6 text-base sm:text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto px-2 transition-colors duration-300">
            Ready to bring your ideas to life? Let's discuss your project and create something amazing together.
          </p>
        </div>
        
        {/* Main Content - Two Column Layout */}
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-start">
          {/* Contact Form */}
          <div className="bg-white dark:bg-[#111] border border-gray-200 dark:border-white/10 p-4 sm:p-6 lg:p-8 hover:shadow-md transition-all duration-300" data-aos="fade-up" data-aos-delay="200">
            <div className="mb-6 sm:mb-8">
              <h3 className="text-xl sm:text-2xl font-semibold text-black dark:text-white mb-2 transition-colors duration-300">
                Send a Message
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base transition-colors duration-300">
                Fill out the form below and I'll get back to you as soon as possible.
              </p>
            </div>

            {/* Success Message */}
            {showSuccess && (
              <div className="mb-6 p-4 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 text-green-800 dark:text-green-300 text-sm sm:text-base animate-fade-in transition-colors duration-300">
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium">Message sent successfully!</span>
                </div>
                <p className="mt-1 ml-7">Thank you for reaching out. I'll get back to you soon.</p>
              </div>
            )}
            
            <form action="https://formsubmit.co/akandeayomidotun444@gmail.com" method="POST" className="space-y-6" onSubmit={handleSubmit}>
              {/* Formsubmit configuration */}
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_subject" value="New Portfolio Contact Form Submission" />
              
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300">Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="John Doe"
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-white/10 focus:border-black dark:focus:border-white text-black dark:text-white focus:outline-none transition-colors duration-300 text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300">Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="john@example.com"
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-white/10 focus:border-black dark:focus:border-white text-black dark:text-white focus:outline-none transition-colors duration-300 text-sm"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300">Subject</label>
                <input
                  type="text"
                  name="subject"
                  placeholder="Enter your subject"
                  required
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-white/10 focus:border-black dark:focus:border-white text-black dark:text-white focus:outline-none transition-colors duration-300 text-sm"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300">Message</label>
                <textarea
                  rows={5}
                  name="message"
                  placeholder="Enter your message..."
                  required
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white dark:bg-[#1a1a1a] border border-gray-200 dark:border-white/10 focus:border-black dark:focus:border-white text-black dark:text-white focus:outline-none transition-colors duration-300 resize-vertical min-h-24 sm:min-h-32 text-sm"
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="w-full bg-black dark:bg-white text-white dark:text-black py-3 sm:py-4 px-4 sm:px-6 hover:bg-gray-800 dark:hover:bg-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-md font-medium text-sm sm:text-base"
              >
                Send Message
              </button>
            </form>
          </div>
          
          {/* Contact Info & Details */}
          <div className="space-y-6 sm:space-y-8">
            {/* Contact Information */}
            <div className="bg-white dark:bg-[#111] border border-gray-200 dark:border-white/10 p-4 sm:p-6 lg:p-8 hover:shadow-md transition-all duration-300" data-aos="fade-up" data-aos-delay="400">
              <h3 className="text-xl sm:text-2xl font-semibold text-black dark:text-white mb-4 sm:mb-6 transition-colors duration-300">
                Let's Connect
              </h3>
              <div className="space-y-4 sm:space-y-6">
                <div className="flex items-start space-x-3 sm:space-x-4 group">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 dark:bg-white/10 flex items-center justify-center group-hover:bg-black dark:group-hover:bg-white group-hover:text-white dark:group-hover:text-black transition-colors duration-300 flex-shrink-0 text-gray-600 dark:text-gray-300">
                    <HiMail className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs sm:text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide transition-colors duration-300">Email</p>
                    <a 
                      href="mailto:akandeayomidotun444@gmail.com" 
                      className="text-black dark:text-white hover:text-gray-600 dark:hover:text-gray-300 transition-colors duration-300 font-medium text-sm sm:text-base break-all"
                    >
                      akandeayomidotun444@gmail.com
                    </a>
                  </div>
                </div>
                
                
                <div className="flex items-start space-x-3 sm:space-x-4 group">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 dark:bg-white/10 flex items-center justify-center group-hover:bg-black dark:group-hover:bg-white group-hover:text-white dark:group-hover:text-black transition-colors duration-300 flex-shrink-0 text-gray-600 dark:text-gray-300">
                    <HiLocationMarker className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs sm:text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide transition-colors duration-300">Location</p>
                    <span className="text-black dark:text-white font-medium text-sm sm:text-base transition-colors duration-300">Lagos, Nigeria</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Social Links */}
            <div className="bg-white dark:bg-[#111] border border-gray-200 dark:border-white/10 p-4 sm:p-6 lg:p-8 hover:shadow-md transition-all duration-300" data-aos="fade-up">
              <h4 className="text-lg sm:text-xl font-semibold text-black dark:text-white mb-4 transition-colors duration-300">
                Follow My Work
              </h4>
              <div className="flex flex-wrap gap-3 sm:gap-4">
                <a
                  href="https://github.com/90TUN"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 border border-gray-200 dark:border-white/10 hover:border-black dark:hover:border-white hover:bg-black dark:hover:bg-white text-black dark:text-white hover:text-white dark:hover:text-black transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
                  title="GitHub"
                >
                  <FaGithub className="w-5 h-5 sm:w-6 sm:h-6" />
                </a>
                
                <a
                  href="https://www.linkedin.com/in/ayomidotun-akande-109160231"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 border border-gray-200 dark:border-white/10 hover:border-black dark:hover:border-white hover:bg-black dark:hover:bg-white text-black dark:text-white hover:text-white dark:hover:text-black transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
                  title="LinkedIn"
                >
                  <FaLinkedin className="w-5 h-5 sm:w-6 sm:h-6" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;